export default defineNuxtRouteMiddleware(async (to) => {
  if (window) {
    window.RM.push(['reset'])
  }
})
